<!--
@Author: Colin Osterhout <ctosterhout>
@Date:   2018-11-10T15:53:37-09:00
@Email:  ctosterhout@alaska.edu
@Last modified by:   ctosterhout
@Last modified time: 2020-02-17T22:16:23-09:00
@License: Released under MIT License. copyright 2019 University of Alaska Southeast.  For more details, see https://opensource.org/licenses/MIT
-->

<template>
<div class="page-footer text-light p-4">
  <b-container>
    <b-row>
      <b-col cols="6"
             md="4"
             lg="2"
             class="page-footer-brand border-right p-4">
        <a href="//acrc.alaska.edu"
           aria-label="ACRC Home Page"
           title="ACRC Home Page">
          <AcrcLogoSquare alt="ACRC small logo"
                          class="page-footer-logo" />
        </a>
      </b-col>
      <b-col cols="6"
             md="4"
             lg="2"
             class="page-footer-links p-3">
        <ul class="text-light nav flex-column">
          <li class="nav-item text-light">
            <a :href="urlMangle('/about/index.html')" aria-label="Visit the About ACRC page" class="nav-link">About</a>
          </li>
          <li class="nav-item text-light">
            <a :href="urlMangle('/projects/index.html')" aria-label="Visit the ACRC Research page" class="nav-link">Research</a>
          </li>
          <li class="nav-item text-light">
            <a :href="urlMangle('/about/contact.html')" aria-label="Visit the ACRC contact page" class="nav-link">Contact Us</a>
          </li>
          <li class="nav-item text-light">
            <a href="//uas.alaska.edu/arts_sciences" aria-label="Visit the UAS Arts &amp; Sciences site" class="nav-link">UAS School of Arts &amp; Sciences</a>
          </li>
        </ul>
      </b-col>
      <b-col cols="6"
             md="4"
             lg="3"
             class="page-footer-address p-3">
        <address>
          Juneau Forestry Sciences Lab<br />
          11175 Auke Lake Way<br />
          Juneau, AK 99801<br />

          (907) 796-6146
        </address>
      </b-col>
      <b-col cols="6"
             md="6"
             lg="2"
             class="page-footer-contact p-3">
        <p><a class="text-light" href="https://visitor.r20.constantcontact.com/d.jsp?llr=wrqtfgiab&p=oi&m=1108308771382&sit=znbs8angb&f=b7c95d31-64f5-4b7a-85b8-31c8c8a9caef">Join our mailing list</a></p>
        <h3 class="text-uppercase text-light">Follow us:</h3>
        <b-nav>
          <b-nav-item title="Follow us on Twitter"
                      class="text-light"
                      href="https://twitter.com/AK_CoastRainCtr">
            <Icon name="brands/twitter"
                  scale="2" />
            <span class="sr-only">Follow us on Twitter</span>
          </b-nav-item>
          <b-nav-item title="Follow us on Instagram"
                      class="text-light"
                      href="https://www.instagram.com/ak_coastrainctr">
            <Icon name="brands/instagram"
                  scale="2" />
            <span class="sr-only">Follow us on Instagram</span>
          </b-nav-item>
        </b-nav>
      </b-col>
      <b-col md="6"
             lg="2"
             class="page-footer-uas-brand p-4">
        <a href="//uas.alaska.edu"
           aria-label="UAS Home Page"
           title="UAS Home Page">
          <img src="https://dq3snl2bhf3xh.cloudfront.net/static/images/uas-logo-vert-reverse.svg"
               alt="UAS Logo">
        </a>
      </b-col>
    </b-row>
    <b-row class="text-center mt-1 px-4">
      <p>The University of Alaska is an affirmative action/equal opportunity employer and educational institution. Contact information, applicable laws, and complaint procedures are included on UA's statement of nondiscrimination available at <a href="http://www.alaska.edu/nondiscrimination">www.alaska.edu/nondiscrimination</a>.</p>
      <p class="w-100">UAS is committed to providing accessible websites: <a href="//uas.alaska.edu/policies/accessibility.html">www.uas.alaska.edu/policies/accessibility.html</a></p>
    </b-row>
  </b-container>
</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../scss/modules/variables';
@import '../scss/modules/bootstrap-extend';

.page-footer {
    background-color: $page-footer-background-color;
}

.page-footer-logo {
    max-height: $height-footer-logo-full-size;
}

.page-footer-links {
    .nav-link {
        text-transform: none;
    }
}

.page-footer-uas-brand {
    max-width: 200px;
}

.text-light .nav-link {
    color: $white;
}
</style>

<script>
import 'vue-awesome/icons/brands/twitter'
import 'vue-awesome/icons/brands/instagram'
import Icon from 'vue-awesome/components/Icon'
import AcrcLogoSquare from '../public/static/images/acrc-logo-square.svg?inline'
import urlMangle from '../js/url-mangle'

export default {
  name: '',
  props: {},
  data: function () {
    return {}
  },
  methods: {
    urlMangle: urlMangle
  },
  components: {
    Icon,
    AcrcLogoSquare
  }
}
</script>
